import { useState } from 'react';
import {
  IconBrandMessenger,
  IconRefresh,
  IconUnlink,
  IconPlayerPause,
  IconPlayerPlay,
  IconAlertTriangle,
} from '@tabler/icons-react';

import useMessengerAccount from '../hooks/useMessengerAccount';
import MessengerConnectFlow from '../../AgentsFlow/channels/plugins/Messenger/ConnectFlow';
import MessengerStatus from './MessengerStatus';

const MessengerPanel = ({ agentId }) => {
  const {
    account,
    loading,
    fetchStatus,
    togglePaused,
    refreshProfile,
    disconnect,
  } = useMessengerAccount(agentId);
  const [actionLoading, setActionLoading] = useState(false);

  const handleConnected = () => {
    fetchStatus();
  };

  const handleTogglePaused = async () => {
    if (!account) return;
    setActionLoading(true);
    try {
      await togglePaused(!account.bot_paused);
    } finally {
      setActionLoading(false);
    }
  };

  const handleRefresh = async () => {
    setActionLoading(true);
    try {
      await refreshProfile();
    } finally {
      setActionLoading(false);
    }
  };

  const handleDisconnect = async () => {
    if (!window.confirm('Tem certeza que deseja desconectar o Messenger?')) {
      return;
    }
    setActionLoading(true);
    try {
      await disconnect();
    } finally {
      setActionLoading(false);
    }
  };

  if (loading && !account) {
    return <div className="cloud-api-panel">Carregando...</div>;
  }

  if (!account) {
    return (
      <div>
        <div
          style={{
            display: 'flex',
            gap: 12,
            alignItems: 'flex-start',
            padding: 14,
            background: '#fffbeb',
            border: '1px solid #fde68a',
            borderRadius: 10,
            margin: '0 0 16px',
          }}
        >
          <IconAlertTriangle
            size={20}
            style={{ color: '#b45309', flexShrink: 0, marginTop: 2 }}
          />
          <div style={{ fontSize: 13, color: '#78350f', lineHeight: 1.5 }}>
            <strong>Atenção:</strong> ao logar no Facebook, na tela
            &ldquo;Quais Páginas você quer usar com o Mercado Agentes?&rdquo;,
            selecione <strong>apenas 1 Página</strong> — a que será
            conectada a este agente. Se você marcar mais de uma, a conexão
            falhará e será necessário refazer o login.
          </div>
        </div>
        <MessengerConnectFlow
          agentId={agentId}
          onConnected={handleConnected}
          onCancel={() => {}}
        />
      </div>
    );
  }

  return (
    <div className="cloud-api-panel">
      <div className="cloud-api-panel__header">
        <IconBrandMessenger size={24} style={{ color: '#0084FF' }} />
        <h3>Messenger</h3>
      </div>

      <div
        className="cloud-api-profile"
        style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}
      >
        {account.profile_picture_url && (
          <img
            src={account.profile_picture_url}
            alt={account.page_name}
            style={{ width: 64, height: 64, borderRadius: '50%' }}
          />
        )}
        <div>
          <div style={{ fontWeight: 600, fontSize: 16 }}>
            {account.page_name || 'Página Facebook'}
          </div>
          {account.page_category && (
            <div style={{ fontSize: 13, color: '#64748b' }}>
              {account.page_category}
            </div>
          )}
          <MessengerStatus account={account} />
        </div>
      </div>

      <div
        style={{
          display: 'flex',
          gap: '0.5rem',
          marginTop: '1rem',
          flexWrap: 'wrap',
        }}
      >
        <button
          className="cloudapi-hero__action-btn"
          onClick={handleTogglePaused}
          disabled={actionLoading}
        >
          {account.bot_paused ? (
            <>
              <IconPlayerPlay size={16} />
              Reativar IA
            </>
          ) : (
            <>
              <IconPlayerPause size={16} />
              Pausar IA
            </>
          )}
        </button>
        <button
          className="cloudapi-hero__action-btn"
          onClick={handleRefresh}
          disabled={actionLoading}
        >
          <IconRefresh size={16} />
          Sincronizar dados
        </button>
        <button
          className="cloudapi-hero__action-btn cloudapi-hero__action-btn--danger"
          onClick={handleDisconnect}
          disabled={actionLoading}
        >
          <IconUnlink size={16} />
          Desconectar
        </button>
      </div>
    </div>
  );
};

export default MessengerPanel;
